export default class CACA1120RequestModel {
  productNo: string
  shhnCd: string
}
